import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'fir-form',
  templateUrl: './fir-form.component.html',
  styleUrls: ['./fir-form.component.css']
})
export class FirFormComponent implements OnInit {
  title = "Add FIR";
  data: any = {};
  formInvalid: boolean = false;
  f: any = {};
  a: any = {};
  Fir_id: number;
  mode: string;
  ComplaintTypelist: any = {}
  Districtlist: any = {}
  Officelist: any = {}
  Statelist: any = {}
  Enactmentlist: any = {}
  fileToUpload: File = null;
  hide: boolean = false;
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  agepattern = "[1-100]";

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
  ) { }
  ngOnInit() {
    this.GetAllData();

    this.route.params.subscribe(params => {
      this.Fir_id = params['Fir_id'];
      this.mode = params['mode'];

      if (this.Fir_id > 0) {
        this.GetFireById(this.Fir_id)
      }
      if (this.mode == 'View') {
        this.hide = true;

      }
    });

    if (this.mode == 'View') {
      this.title = "View FIR ";
    }
    else if (this.mode == 'Edit') {
      this.title = "Edit FIR";
    }


  }
  GetAllData() {
    //Get All Complaint type
    this.data = this.userService.GetAllComplaintT();
    this.data.subscribe(
      (response: any) => {
        this.ComplaintTypelist = response.Result;
      })


    //get all offices
    this.data = this.userService.GetAllOffice();
    this.data.subscribe(
      (response: any) => {
        this.Officelist = response.Result;

      })

    //get all distrct

    this.data = this.userService.GetAllDistrict();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response.Result;
      })

    //get all state


    this.data = this.userService.GetAllState();
    this.data.subscribe(
      (response: any) => {
        this.Statelist = response.Result;
      })

    //get all enactment

    this.data = this.userService.GetAllEnactment();
    this.data.subscribe(
      (response: any) => {
        this.Enactmentlist = response.Result;
      })
  }
  SaveFir(Fir: NgForm) {
    // this.CalculateAge(Fir.value.Fir_Infmnt_Age)
    // {
    //   return false;
    // }
    debugger;

    console.log('Fir Forms');
    console.log(Fir.value);

    if (Fir.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }

    else {
      console.log('Data');
      console.log(Fir.value);
      Fir.value.Fir_Brief_Path = this.getFeasibilityFirBriefFUrl();
      Fir.value.Fir_comp_Sign = this.getFeasibilitySignFUrl();
      this.data = this.userService.PostFir(Fir.value);
      this.data.subscribe(
        (response) => {
          Fir.reset();
          Fir.resetForm();
          Fir.form.markAsPristine();
          Fir.form.markAsUntouched();
          swal('Success!', 'FIR Added Successfully .', 'success');
          this.router.navigate(['/home/fir/']);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });


    }
  }

  GetFireById(Fir_id) {
   this. GetAllData() ;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetByIdFir(Fir_id);
    this.data.subscribe(
      (response: any) => {
        this.f = response;

        console.log('Get By Id');
        console.log(this.f);
        console.log(response);
        //for date displaying in view

        if (this.f.Fir_Date != null)
          this.f.Fir_Date = ((this.f.Fir_Date).split('T'))[0];

        if (this.f.Fir_Offence_Date != null)
          this.f.Fir_Offence_Date = ((this.f.Fir_Offence_Date).split('T'))[0];

        if (this.f.Fir_Infrtn_Recv_Date != null)
          this.f.Fir_Infrtn_Recv_Date = ((this.f.Fir_Infrtn_Recv_Date).split('T'))[0];

        if (this.f.Fir_Infmnt_issue_Date != null)
          this.f.Fir_Infmnt_issue_Date = ((this.f.Fir_Infmnt_issue_Date).split('T'))[0];

        if (this.f.Fir_Dispatch_Date != null)
          this.f.Fir_Dispatch_Date = ((this.f.Fir_Dispatch_Date).split('T'))[0];



        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }
  UpdateFir(Fir: NgForm) {
    // this.CalculateAge(Fir.value.Fir_Infmnt_Age)
    // {
    //   return false;
    // }
    Fir.value.Fir_id = this.Fir_id;
    Fir.value.Fir_Brief_Path = this.getFeasibilityFirBriefFUrl();
    Fir.value.Fir_comp_Sign = this.getFeasibilitySignFUrl();
    this.data = this.userService.UpdateFir(Fir.value, this.Fir_id);
    this.data.subscribe(
      (response) => {
        Fir.reset();
        Fir.resetForm();
        Fir.form.markAsPristine();
        Fir.form.markAsUntouched();

        swal('Success!', 'Fir updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/fir/']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

  }

  //upload1


  imageUpload1(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage1(data);
      x.subscribe(
        (response) => {

        }, (error) => {
          let i: any = document.getElementById('Fir_Brief_Path');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Fir_Brief_Path');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getFeasibilityFirBriefFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Fir_Brief_Path');
      console.log('Fir file');
      console.log(imagename.files[0].name);
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //upload2

  imageUpload2(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage2(data);
      x.subscribe(
        (response) => {

        }, (error) => {
          let i: any = document.getElementById('Fir_comp_Sign');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Fir_comp_Sign');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getFeasibilitySignFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Fir_comp_Sign');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  Cancel() {

    this.f.Fir_id = '';
    this.f.Fir_Crime_No = '';
    this.f.Fir_CT_Id_Fk = '';
    this.f.Fir_Police_Stn = '';
    this.f.Fir_Date = '';
    this.f.Fir_Distrct_Id_Fk = '';
    this.f.Fir_State_Id_Fk = '';
    this.f.Fir_Off_Id_Fk = '';
    this.f.Fir_Enact_id_Fk = '';
    this.f.Fir_Section = '';
    this.f.Fir_Offence_Date = '';
    this.f.Fir_Infrtn_Recv_Date = '';
    this.f.Fir_Infrmtn_Type = '';
    this.f.Fir_Occurnc_Place = '';
    this.f.Fir_Distnc_PS = '';
    this.f.Fir_Infmnt_Name = '';
    this.f.Fir_Infmnt_Father = '';
    this.f.Fir_Infmnt_Age = '';
    this.f.Fir_Infmnt_Nationlty = '';
    this.f.Fir_Infmnt_Pass_No = '';
    this.f.Fir_Infmnt_issue_Date = '';
    this.f.Fir_Infmnt_Issu_Place = '';
    this.f.Fir_Infmnt_Occptn = '';
    this.f.Fir_Infmnt_Adress = '';
    this.f.Fir_Infmnt_Distrc_Id_Fk = '';
    this.f.Fir_Resn_Delay = '';
    this.f.Fir_Proprty_Stoln = '';
    this.f.Fir_Totl_Proprty_Stoln = '';
    this.f.Fir_UD_Case_No = '';
    this.f.Fir_Brief_Path = '';
    this.f.Fir_Actn_Takn = '';
    this.f.Fir_Detect_Name = '';
    this.f.Fir_Rank = '';
    this.f.Fir_Refuse_Inv = '';
    this.f.Fir_Actn_Distrc_Id_Fk = '';
    this.f.Fir_comp_Sig = '';
    this.f.Fir_Dispatch_Date = '';
    this.f.Fir_Disptch_P_Name = '';
    this.f.Fir_Limt_PS = '';
    this.f.Fir_Detail_Suspctd = '';
    this.f.Fir_Jurdct_PS = '';
  }

  CalculateAge(Age) {
    debugger
    if (Age < 18) {
      this.f.Fir_Infmnt_Age = null;
      swal('waring', 'Age should be greater than 18 years', 'warning')
    }
  }
}












// WEBPACK FOOTER //
// ./src/app/FIR/fir-form/fir-form.component.ts